import React from 'react';
import './styles.css';
function Legend() {
    return (React.createElement("div", { className: "legend" },
        React.createElement("div", { className: "legend-item" },
            React.createElement("div", { className: "legend-indicator store-hours" }),
            React.createElement("span", null, "Store Hours")),
        React.createElement("div", { className: "legend-item" },
            React.createElement("div", { className: "legend-indicator available" }),
            React.createElement("span", null, "Available")),
        React.createElement("div", { className: "legend-item" },
            React.createElement("div", { className: "legend-indicator no-service" }),
            React.createElement("span", null, "No Service")),
        React.createElement("div", { className: "legend-item" },
            React.createElement("div", { className: "legend-indicator override" }),
            React.createElement("span", null, "Override"))));
}
export { Legend };
//# sourceMappingURL=Legend.js.map